import React, { createContext, useState } from "react";

export const SearchVectorContext = createContext(); 

export const SearchVectorProvider = ({ children }) => {
    const [searchVector, setSearchVector] = useState(null);

  return (
    <SearchVectorContext.Provider value={{ searchVector, setSearchVector }}>
      {children} 
    </SearchVectorContext.Provider>
  );
};
